import './About.css';
import profileImage from './Profile.jpeg';

function About() {
  return (
    <div className="about">
      <img src={profileImage} alt="Fabian Trejo" />
      <h1>Fabian Trejo</h1>
      <h3 className="about-title">Senior Software Engineer</h3>
      <p>Senior Software Engineer with a background in data science and machine learning, specializing in deep learning, generative AI, and cloud-native architectures. Experienced in building end-to-end solutions — from ML model pipelines to scalable microservices on AWS and Azure — using Python, SQL, and modern cloud tooling. Certified across Google Cloud, NVIDIA, and IBM platforms. Passionate about turning complex data into practical, high-impact products through cross-functional collaboration.</p>
    </div>
  );
}

export default About;